import React from 'react';
import Immutable from 'immutable';
import c from 'classnames';

import {
  Accordion,
  Button,
  AccordionItem,
  WysiwygField,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  PARAGRAPH_VIEW_MODE_DEFAULT,
  PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME,
} from '../../../config/constants';

import './style.scss';

const TitleComponent = (props) => {
  const { className, children } = props;

  return (
    <h4 className={className}>{children}</h4>
  );
};

const ParagraphAccordeon = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT }) => {
  const title = entity.getIn(['field_title', 0, 'value'], null);
  const viewModeIsCampaignPageColorTheme = viewMode === PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME;

  const colClasses = c('col-12 col-md-10 offset-md-1', {
    'col-lg-8 offset-lg-2': !viewModeIsCampaignPageColorTheme,
    'col-lg-7 offset-lg-0': viewModeIsCampaignPageColorTheme,
  });

  return (
    <div className="ParagraphAccordeon">
      <Container>
        <div className="row">
          <div className={colClasses}>
            {title && (
              <div className="ParagraphAccordeon__title">
                <h2 className={`${viewModeIsCampaignPageColorTheme ? 'asH!' : ''}`}>{title}</h2>
              </div>
            )}
            <Accordion>
              {entity.getIn(['field_paragraphs'], Immutable.List()).map((item) => {
                const accordeonEntity = item.get('entity');
                return (
                  <AccordionItem
                    key={item.get('target_uuid')}
                    entity={accordeonEntity}
                    iconClassName="icon-caret-down"
                    title={accordeonEntity.getIn(['field_title', 0, 'value'])}
                    content={(
                      <div>
                        <WysiwygField html={accordeonEntity.getIn(['field_text', 0, 'processed'], '')} />
                        {accordeonEntity.getIn(['field_link', 0]) && (
                          <div className="Accordion__item__content__link">
                            <Button className="Button Button--secondary" href={accordeonEntity.getIn(['field_link', 0, 'alias'], accordeonEntity.getIn(['field_link', 0, 'uri']))}>{accordeonEntity.getIn(['field_link', 0, 'title'])}
                              <i className="icon icon-before icon-arrow-right" />
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                    titleComponent={TitleComponent}
                  />
                );
              })}
            </Accordion>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphAccordeon;
